<template>
  <div ref="datePicker" class="date-picker">
    <button class="date-picker__value" type="button" @click="toggle">
      {{ this.selectedMoment.format('MMMM D (M/D)') }}
    </button>
    <div v-show="isOpen" class="date-picker__chooser">
      <div class="date-picker__month-chooser">
        <app-button type="button" @click="monthPrevious">&lt;</app-button>
        <span class="date-picker__month-text">{{ month }}</span>
        <app-button type="button" @click="monthNext">&gt;</app-button>
      </div>
      <div class="date-picker__day-chooser">
        <div v-for="day in paddingBeginning" :key="day"></div>
        <button
          v-for="day in daysInMonth"
          :key="day"
          class="date-picker__day"
          :class="getDateClasses(day)"
          type="button"
          @click="select(day)"
        >
          {{ day }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import AppButton from '@/components/AppButton.vue'

export default {
  components: {
    AppButton,
  },
  props: {
    value: {
      type: Number,
      default: moment().valueOf(),
    },
  },
  computed: {
    daysInMonth() {
      const d = moment(this.selectedMoment).date(-1)
      return Array(d.date())
        .fill()
        .map((_, i) => i + 1)
    },
    firstDayOfWeek() {
      return moment(this.selectedMoment)
        .date(1)
        .day()
    },
    month() {
      return this.selectedMoment.format('MMMM')
    },
    paddingBeginning() {
      return Array(this.firstDayOfWeek).fill()
    },
  },
  data() {
    return {
      now: moment(),
      isOpen: false,
      selectedMoment: moment(this.value),
    }
  },
  mounted() {
    window.addEventListener('click', event => {
      if (!this.$refs.datePicker) return
      if (!this.$refs.datePicker.contains(event.target)) this.close()
    })
  },
  methods: {
    close() {
      this.isOpen = false
    },
    getDateClasses(day) {
      return {
        'date-picker__day--current':
          this.selectedMoment.month() === this.now.month() &&
          day === this.now.date(),
        'date-picker__day--selected': day === this.selectedMoment.date(),
      }
    },
    monthNext() {
      const newMonth = (this.selectedMoment.month() + 1) % 12
      this.selectedMoment = moment(this.selectedMoment).month(newMonth)
      this.$emit('input', this.selectedMoment.valueOf())
    },
    monthPrevious() {
      const newMonth =
        this.selectedMoment.month() === 0 ? 11 : this.selectedMoment.month() - 1
      this.selectedMoment = moment(this.selectedMoment).month(newMonth)
      this.$emit('input', this.selectedMoment.valueOf())
    },
    open() {
      this.isOpen = true
    },
    select(day) {
      this.selectedMoment = moment(this.selectedMoment).date(day)
      this.$emit('input', this.selectedMoment.valueOf())
    },
    toggle() {
      this.isOpen ? this.close() : this.open()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/variables';

.date-picker {
  position: relative;

  &__chooser {
    background: #fff;
    box-shadow: 0 2px 3px #00000044;
    position: absolute;
    top: calc(100% + 1px);
    width: 100%;
    z-index: 10;
  }

  &__day {
    background: #fff;
    border: 1px solid #fff;
    border-radius: 3px;
    cursor: pointer;

    &:hover {
      background: $colorBackgroundDark;
    }

    &--current {
      border: 1px solid $colorPrimary;
    }

    &--selected {
      background: $colorSecondary;
    }
  }

  &__day-chooser {
    display: grid;
    gap: 1vw;
    grid-template-columns: repeat(7, 1fr);
    grid-auto-rows: 3rem;
    padding: 1rem 0;
  }

  &__month-chooser {
    align-items: center;
    display: flex;
  }

  &__month-text {
    flex: 1;
    text-align: center;
  }

  &__value {
    background: #fff;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    padding: 1rem;
    text-align: left;
    width: 100%;
  }
}
</style>
